import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({

  selector: 'file-uploader',

  templateUrl: './file-uploader.component.html',

  styleUrls: ['./file-uploader.component.css']

})

export class FileUploaderComponent implements OnInit {

  errorMessage: string = '';

  selectedFile: File;

  @Input() allowedFileTypes: string[] = ['jpg', 'jpeg'];

  @Input() maxFileSize: number = 1;

  @Output() submit = new EventEmitter();

  reqModel: FormGroup = this.formBuilder.group({

    strFile: new FormControl(),

  });

  constructor(

    private formBuilder: FormBuilder

  ) { }

  ngOnInit(): void {

    this.maxFileSize = this.maxFileSize * (1024 * 1024);

  }

  get acceptTypes() {

    return this.allowedFileTypes.map(t => '.' + t).join(',');

  }

  onFileSelected(event: Event): void {

    const input = event.target as HTMLInputElement;

    this.errorMessage = '';

    if (input.files && input.files.length > 0) {

      this.removeFile()

      this.handleFile(input.files[0]);

    }

    input.value = '';

  }

  private handleFile(file: File): void {

    const fileExtension = file.name.split('.').pop()?.toLowerCase();

    if (!fileExtension || !this.allowedFileTypes.includes(fileExtension)) {

      this.errorMessage = `فرمت فایل ${fileExtension ? fileExtension : ''} مجاز نیست. فرمت‌های مجاز: ${this.allowedFileTypes.join(', ')}`;

      return;

    }

    if (file.size > this.maxFileSize) {

      const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);

      const maxSizeMB = (this.maxFileSize / (1024 * 1024));

      this.errorMessage = `حجم فایل ( ${fileSizeMB} مگابایت) بیشتر از حد مجاز (${maxSizeMB} مگابایت) است.`;

      return;

    }

    this.selectedFile = file;

    this.reqModel.patchValue({

      strFile: file,

    })

    this.submit.emit(this.reqModel.value)

  }

  removeFile() {

    this.selectedFile = undefined;

    this.errorMessage = '';

    this.reqModel.patchValue({

      strFile: '',

    })

    this.submit.emit(this.reqModel.value)

  }

}
